import type { EntityAction } from "@firecms/core";
import { AccountBalanceWalletIcon } from "@firecms/ui";
import type { AssignedParticipant } from "../../collections/participants";
import { getAdminT } from "../../i18n/getAdminT";
import { getAdminUiLocale } from "../../i18n/getAdminUiLocale";
import { tableOnlyEntityAction } from "../entityActionDefaults";
import { openParticipantEconomyDialog } from "./participantEconomyBridge";

export function buildViewParticipantEconomyEntityAction(): EntityAction<AssignedParticipant> {
  const t = getAdminT(getAdminUiLocale());

  return {
    key: "view-participant-economy",
    name: t("participantEconomy.entityAction"),
    icon: <AccountBalanceWalletIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: async ({ entity }) => {
      if (!entity) {
        return;
      }
      openParticipantEconomyDialog(entity.id);
    },
  };
}
